import React from 'react';
import ReadMoreReact from 'read-more-react';

interface AutoLinkerProps {
    text: string;
}

const AutoLinker: React.FC<AutoLinkerProps> = ({ text }) => {
    const replaceWithLink = (text: string) => {
        let regex = /\[\[(?:<[\w\sa-z0-9="'();\-:]*)*(?:>)*(?:\s)?([0-9]+)(?:\s)?(?:<\/\w*>)*\]\]/g;
        text = text.replace(regex, (match, p1) => {
            return `<a class="Ticket-Link" href="./ticket/${p1}">${p1}</a>`;
        });
        regex = /\[\[KB([0-9]+)\]\]/ig;
        text = text.replace(regex, (match, p1) => {
            return `<a class="KB-Link" href="./KBase/Default.aspx?KB_Id=${p1}">KB${p1}</a>`;
        });

        regex = /\[\[(@[a-z,A-Z,0-9, ]+)\]\]/ig;
        return text.replace(regex, (match, p1) => {
            return `<span class="Tag-Link">${p1}</span>`;
        });
    };

    if (!text) return null;

    return (
        <div dangerouslySetInnerHTML={{ __html: replaceWithLink(text).replaceAll('\r\n', '<br/>') }} />
        // <ReadMoreReact text={replaceWithLink(text).replaceAll('\r\n', '<br/>')}></ReadMoreReact>
    );
};

export default AutoLinker;